import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { authorNameAuthor$key } from "~/queries/__generated__/authorNameAuthor.graphql";

import { StyledEntityLink } from "./styles";

export type Props = {
  className?: string;
  reference: authorNameAuthor$key;
};

export const AuthorName: FunctionComponent<Props> = ({ className, reference: reference_ }) => {
  const author = useFragment(
    graphql`
      fragment authorNameAuthor on Author {
        ...entityLink
        name
      }
    `,
    reference_,
  );
  return (
    <StyledEntityLink className={className} reference={author}>
      {author.name}
    </StyledEntityLink>
  );
};

AuthorName.displayName = "AuthorName";
